import React, { useState } from "react";
import {
  QUERY_KEY_FOR_TALENT_PROFILE,
  useGetTalentProfile,
} from "features/settings/hooks/useGetTalentProfile";
import { AddCertification } from "./AddCertification";
import { TCertification } from "features/settings/types";
import { useDelete } from "hooks/useDelete";
import { Popconfirm, Skeleton } from "antd";
import { ProfileNavigationButtons } from "./ProfileNavigationButtons";
import { useNavigate } from "react-router-dom";
import { getNextSection } from "../../services/profileNavigationService";

const deleteEndPointUrl = "delete-certification/";

export const Certifications: React.FC<{
  data: TCertification[];
  isLoading?: boolean;
}> = ({ data, isLoading }) => {
  const navigate = useNavigate(); // Add this
  const [addHistory, setAddHistory] = useState(false);
  const [id, setId] = useState<number>();
  const { removeData } = useDelete({
    queryKey: QUERY_KEY_FOR_TALENT_PROFILE,
    deleteEndPointUrl,
  });

  const handleAddCertification = () => {
    setId(undefined);
    setAddHistory(true);
  };

  const handleCertification = (id: number) => {
    setId(id);
    setAddHistory(true);
  };

  const handleNext = () => {
    const nextSection = getNextSection(window.location.pathname);
    if (nextSection) {
      navigate(nextSection.link);
    }
  };

  return (
    <>
      <AddCertification
        id={id}
        open={addHistory}
        handleClose={() => {
          setAddHistory(false);
          setId(undefined);
        }}
      />

      <div className="mt-6 max-w-5xl">
        {/* HEADER */}
        <div className="flex items-start justify-between mb-4">
          <div>
            <h4 className="text-base font-semibold text-primary">
              Certifications
            </h4>
            <p className="text-sm text-gray-500">
              Add your professional certifications
            </p>
          </div>

          <button
            onClick={handleAddCertification}
            className="bg-primary text-white text-sm font-medium px-4 py-2 rounded-md flex items-center gap-1 hover:bg-primary/90"
          >
            <i className="ri-add-line"></i>
            <span>Add New</span>
          </button>
        </div>

        <Skeleton active loading={isLoading}>
          <div className="space-y-4">
            {data.map((item) => (
              <div
                key={item.id}
                className="border border-gray-200 bg-white rounded-lg px-4 py-4 hover:border-secondary transition"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-xs font-medium text-gray-500">
                      {item.issuer}
                    </p>

                    <h4 className="text-sm font-semibold text-primary mt-1">
                      {item.title}
                    </h4>

                    <div className="flex items-center gap-2 mt-3 text-sm text-gray-500">
                      <i className="ri-calendar-line"></i>
                      <span>
                        {item.issued_date
                          ? new Date(item.issued_date).getFullYear()
                          : "N/A"}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <i
                      onClick={() => handleCertification(item.id)}
                      className="ri-pencil-fill text-gray-400 cursor-pointer text-xl hover:text-primary"
                    ></i>

                    <Popconfirm
                      okButtonProps={{
                        style: {
                          backgroundColor: "#f5222d",
                          color: "#ffffff",
                        },
                      }}
                      title="Delete Certification"
                      description="Are you sure you want to delete this certification?"
                      onConfirm={() => removeData(item.id)}
                    >
                      <i className="ri-delete-bin-line text-gray-400 cursor-pointer text-xl hover:text-red-600"></i>
                    </Popconfirm>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Skeleton>

        <div className="mt-6">
          <ProfileNavigationButtons
            hasForm={false}
            onNext={handleNext}
            nextButtonLabel="Next"
          />
        </div>
      </div>
    </>
  );
};
